import chalk from 'chalk';

export const logger = {
  info(message: string) {
    console.log(chalk.blue('ℹ'), message);
  },

  success(message: string) {
    console.log(chalk.green('✓'), message);
  },

  warning(message: string) {
    console.log(chalk.yellow('⚠'), message);
  },

  error(message: string) {
    console.log(chalk.red('✖'), message);
  },

  log(message: string) {
    console.log(message);
  },

  title(message: string) {
    console.log(chalk.bold.cyan(`\n${message}\n`));
  },

  newLine() {
    console.log();
  },
};

